var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductHuntLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 12C24 18.6276 18.6276 24 12 24C5.3724 24 0 18.6276 0 12C0 5.3724 5.3724 0 12 0C18.6276 0 24 5.3724 24 12Z",
    fill: "#FF6154"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5971 12H10.1969V8.4H13.5971C14.0745 8.4 14.5323 8.58964 14.8699 8.92721C15.2074 9.26477 15.3971 9.72261 15.3971 10.2C15.3971 10.6774 15.2074 11.1352 14.8699 11.4728C14.5323 11.8104 14.0745 12 13.5971 12ZM13.5971 6H7.79688V18H10.1969V14.4H13.5971C14.711 14.4 15.7793 13.9575 16.5669 13.1698C17.3546 12.3822 17.7971 11.3139 17.7971 10.2C17.7971 9.08609 17.3546 8.0178 16.5669 7.23015C15.7793 6.4425 14.711 6 13.5971 6Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductHuntLogo);
export default __webpack_public_path__ + "static/media/Product-Hunt-Logo.fd1ccb591b158857dbca4c267f3dc26c.svg";
export { ForwardRef as ReactComponent };